module.exports = __webpack_public_path__ + "static/media/hk.047d172e.jpeg";